<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path d="M879.3 80.3H146c-36.2 0-65.7 29.5-65.7 65.7v260c0 36.2 29.5 65.7 65.7 65.7h71.7v-29c0-16 13-29 29-29H146c-4.2 0-7.7-3.4-7.7-7.7V146c0-4.2 3.4-7.7 7.7-7.7h733.3c4.2 0 7.7 3.4 7.7 7.7v260c0 4.2-3.4 7.7-7.7 7.7H246.7c16 0 29 13 29 29v29h603.7c36.2 0 65.7-29.5 65.7-65.7V146c-.1-36.2-29.6-65.7-65.8-65.7zm0 493.4H508.7c-36.2 0-65.7 29.5-65.7 65.7v113h29c16 0 29 13 29 29v-142c0-4.2 3.4-7.7 7.7-7.7h370.7c4.2 0 7.7 3.4 7.7 7.7v260c0 4.2-3.4 7.7-7.7 7.7H508.7c-4.2 0-7.7-3.4-7.7-7.7v-118c0 16-13 29-29 29h-29v89c0 36.2 29.5 65.7 65.7 65.7h370.7c36.2 0 65.7-29.5 65.7-65.7v-260c-.1-36.3-29.6-65.7-65.8-65.7zM443 752.3v58h-80.3c-30.8 0-57.9-7.7-80.4-22.8-18.1-12.2-33-28.9-44.1-49.8-17.8-33.3-20.2-65.7-20.4-69.3V471.7h58v193.8c.4 4 2.9 25.7 14.3 46.2 15.2 27.3 38.9 40.6 72.7 40.6H443z" data-follow-fill="currentColor" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
